// @flow

import { DEPLOYMENT_ENVIRONMENT } from 'shared/config';

import * as rum from '../cloudwatchRum/rum';
import { captureException } from './errorTracking/honeybadger';

export const initRealUserMonitoring = () => {
  if (!DEPLOYMENT_ENVIRONMENT || DEPLOYMENT_ENVIRONMENT === 'local') return;

  rum.init();
};

export const recordRUMEvent = (eventName: string, data: Object) => {
  if (rum.awsRum === undefined) return;

  try {
    rum.awsRum.recordEvent(eventName, data);
    console.log(`Recorded CloudWatch RUM event: ${eventName}`);
  } catch (e) {
    console.error('Error recording CloudWatch RUM event:', e);
    captureException(
      e,
      `Failed to record CloudWatch RUM event with name: ${eventName} and data: ${JSON.stringify(
        data
      )}`
    );
  }
};
